import React, { Component } from 'react'
import PropTypes from 'prop-types'
import numberConverter from '../../../../../../utils/tuition/numberForCurrency'
export default class ToolTipContent extends Component {
  static propTypes = {
    isMobile: PropTypes.bool,
    milestone: PropTypes.any.isRequired,
  }
  render() {
    const {
      milestone: { company_or_university, milestone_title, salary },
      isMobile,
    } = this.props
    let title =
      milestone_title && milestone_title !== 'Unspecified'
        ? milestone_title
        : ''
    // if (type === 'education') {
    //   if (level && level !== '' && major && major !== '') title = `${capitalize(level)} of ${capitalize(major)}`
    //   else if ((!level || level ==='') && major && major !== '') title = capitalize(major)
    // }

    return (
      <div>
        <h5
          style={{
            color: 'white',
            textAlign: 'center',
            margin: 0,
            ...(isMobile ? { fontSize: 12 } : { fontSize: 14 }),
          }}
        >
          {title}
        </h5>
        {company_or_university && (
          <h6
            style={{
              color: '#ddd',
              marginBottom: 2,
              textAlign: 'center',
              ...(isMobile ? { fontSize: 10 } : { fontSize: 12 }),
            }}
          >
            @{company_or_university}
          </h6>
        )}
        {salary && (
          <h6
            className="text-center mb-0"
            style={{
              color: 'white',
              ...(isMobile ? { fontSize: 10 } : { fontSize: 12 }),
            }}
          >
            Est. Salary: ${numberConverter(salary)}
          </h6>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/Pathways/ToolTipContent.js